import { cn } from '@utils/cn';
import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

export const FormRequired = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });

  return (
    <span
      {...props}
      className={cn('flex w-full justify-end text-xs leading-5 text-neutral-700', className)}>
      {children || ['*', t('required')].join(' ')}
    </span>
  );
};
